import { apiUrl } from '../../../config/api';
export async function fetchBuscarPartidoFilters() {
    const [resLigas, resCanchas, resAdversarios] = await Promise.all([
        fetch(apiUrl('busqueda/ligas')),
        fetch(apiUrl('busqueda/canchas')),
        fetch(apiUrl('busqueda/adversarios'))
    ]);

    return Promise.all([resLigas.json(), resCanchas.json(), resAdversarios.json()]);
}

export async function fetchBuscarPartidoResults(url) {
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response.json();
}
